



















import { Prop, Vue, Component, Watch } from 'vue-property-decorator'

@Component({ name: 'ArrayString',
  components: {},
  mixins: [] })
export default class extends Vue {
    @Prop()
    readonly value!:any[]

    @Prop({
      default: 3
    })
    readonly summary!:number

    @Prop({ default: null })
    readonly jsonKey!:string|null

    displayValue:string = ''
    dataItems?:any[] = []

    @Watch('value')
    onWatchValue () {
      let dataArray = this.value ? this.value : []
      const jsonKey = this.jsonKey !== undefined ? this.jsonKey : undefined
      const keyArr = jsonKey ? jsonKey.split('.') : []
      let displayData = dataArray.map(data => {
        let value = data
        if (keyArr.length > 0) {
          keyArr.forEach(key => {
            value = value[key]
          })
        }
        return value
      })
      this.dataItems = Array.from(new Set(displayData))
      if (this.dataItems.length > 5) {
        this.displayValue = this.dataItems.slice(0, this.summary).toString() + '...'
      } else if (this.dataItems.length > 0) {
        this.displayValue = this.dataItems.toString()
      }
    }

    mounted () {
      this.onWatchValue()
    }
}
